<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12" class="pt-0">
      <v-row justify="space-between">
        <v-col cols="6">
          <h1>Заказы</h1>
        </v-col>
        <v-col cols="3" class="search-col">
          <v-text-field
                  v-model="search"
                  prepend-icon="mdi-magnify"
                  label="Поиск"
                  single-line
                  otlined
                  hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-tabs v-model="tab">
        <v-tab>Все</v-tab>
        <v-tab>Новые</v-tab>
        <v-tab>Обработанные</v-tab>
        <v-tab>Отмененные</v-tab>
      </v-tabs>
      <v-row>
        <v-col cols="12" sm="12">
          <v-slide-group class="text-right">
            <v-slide-item v-if="filters.created_at.valueFrom || filters.created_at.valueTo">
              <v-chip
                      class="v-btn ml-3"
                      close
                      @click:close="filters.created_at.valueFrom = null; filters.created_at.valueTo = null;"
                      color="#FAFCFF"
                      outlined
                      label
                      text-color="currentColor"
              >
                {{ filters.created_at.valueFrom }}{{filters.created_at.valueFrom && filters.created_at.valueTo ? ' - ' :
                ''}}{{ filters.created_at.valueTo }}
              </v-chip>
            </v-slide-item>
            <v-slide-item v-if="filters.sum.valueFrom || filters.sum.valueTo">
              <v-chip
                      class="v-btn ml-3"
                      close
                      @click:close="filters.sum.valueFrom = null; filters.sum.valueTo = null;"
                      color="#FAFCFF"
                      outlined
                      label
                      text-color="currentColor"
              >
                {{ filters.sum.valueFrom ? filters.sum.valueFrom + ' UAH': ''}}{{filters.sum.valueFrom &&
                filters.sum.valueTo ? ' - ' : ''}}{{ filters.sum.valueTo ? filters.sum.valueTo + ' UAH': '' }}
              </v-chip>
            </v-slide-item>
            <v-slide-item v-if="filters.type.value ">
              <v-chip
                      class="v-btn ml-3"
                      close
                      @click:close="filters.type.value = null"
                      color="#FAFCFF"
                      outlined
                      label
                      text-color="currentColor"
              >
                {{ getPayText(filters.type.value) }}
              </v-chip>
            </v-slide-item>
            <v-slide-item v-if="filters.source.value ">
              <v-chip
                      class="v-btn ml-3"
                      close
                      @click:close="filters.source.value = null"
                      color="#FAFCFF"
                      outlined
                      label
                      text-color="currentColor"
              >
                {{ filters.source.value }}
              </v-chip>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
      <v-data-table
              no-data-text="Нет заказаов"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="orders"
              :search="search"
              :options.sync="options"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :footer-props="footerProps"
              :server-items-length="total"
              :loading="loading"
              :fixed-header="true"
              height="70vh"
              :item-class="getItemClass"
              :items-per-page="15"
              loading-text="Загрузка заказов... Подождите пожалуйста"
      >
        <template v-slot:header.created_at>
          Заказ поступил<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.created_at.valueFrom || filters.created_at.valueTo}"
                 @click.stop.prevent="filters.created_at.modal = !filters.created_at.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:header.sum>
          Сумма<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.sum.valueFrom || filters.sum.valueTo}"
                 @click.stop.prevent="filters.sum.modal = !filters.sum.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:header.type_text>
          Тип оплаты<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.type.value}"
                 @click.stop.prevent="filters.type.modal = !filters.type.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:header.source>
          Источник заказа<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.source.value}"
                 @click.stop.prevent="filters.source.modal = !filters.source.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:item.id="{ item }">
          <a style="color: #2196F3;" @click.stop="order = {}; order = item">№ {{ item.id }}</a>
        </template>
        <template v-slot:item.client_id="{ item }">
            <router-link :to="{ name: 'user-edit', params: { id: item.client_id } }">{{ item.client_id}}</router-link>
        </template>
        <template v-slot:item.type_text="{ item }">
          {{ item.type_text }} <span v-if="item.type_id === 3 && !item.is_payed" class="red-circle"></span>
        </template>
        <template v-slot:item.is_local="{ item }">
          {{  item.is_local ? 'Одесса' : 'Доставка НП'}}
          <template v-if="item.shipping_note">
          <br>({{ item.shipping_note}})
          </template>
        </template>
        <template v-slot:item.delivery_at="{ item }">
          {{  item.delivery_at ? item.delivery_at : ''}}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click.stop="$router.push({ name: 'product-edit', params: { id: item.id } })">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-dialog
            v-model="filters.created_at.modal"
            max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-dialog
                      ref="createdAtValueFromModal"
                      v-model="filters.created_at.valueFromModal"
                      :return-value.sync="filters.created_at.tempValueFrom"
                      width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                          v-model="filters.created_at.tempValueFrom"
                          label="От"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                        v-model="filters.created_at.tempValueFrom"
                        scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                          text
                          color="primary"
                          @click="filters.created_at.valueFromModal = false"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                          text
                          color="primary"
                          @click="$refs.createdAtValueFromModal.save(filters.created_at.tempValueFrom  )"
                  >
                    Выбрать
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col>
              <v-dialog
                      ref="createdAtValueToModal"
                      v-model="filters.created_at.valueToModal"
                      :return-value.sync="filters.created_at.tempValueTo"
                      width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                          v-model="filters.created_at.tempValueTo"
                          label="От"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                        v-model="filters.created_at.tempValueTo"
                        scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                          text
                          color="primary"
                          @click="filters.created_at.valueToModal = false"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                          text
                          color="primary"
                          @click="$refs.createdAtValueToModal.save(filters.created_at.tempValueTo  )"
                  >
                    Выбрать
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setCreatedAtFilter">Выбрать</v-btn>

          <v-btn
                  outlined
                  @click="filters.created_at.modal = false"
          >
            Нет
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
            v-model="filters.sum.modal"
            max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                      label="От"
                      outlined
                      v-model="filters.sum.tempValueFrom"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                      label="До"
                      outlined
                      v-model="filters.sum.tempValueTo"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setSumFilter">Выбрать</v-btn>

          <v-btn
                  outlined
                  @click="filters.sum.modal = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
            v-model="filters.source.modal"
            max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-select
                  label="Источник"
                  :items="sources"
                  v-model="filters.source.tempValue"
                  outlined>
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setSourceFilter">Выбрать</v-btn>
          <v-btn
                  outlined
                  @click="filters.source.modal = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
            v-model="filters.type.modal"
            max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-select
                  label="Тип оплаты"
                  :items="payType"
                  :item-value="type => type.id"
                  :item-text="type => type.name"
                  v-model="filters.type.tempValue"
                  outlined>
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setTypeFilter">Выбрать</v-btn>
          <v-btn
                  outlined
                  @click="filters.type.modal = false"
          >
            Нет
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <order-modal v-model="order" :terminals="terminals"></order-modal>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import OrderService from "../../api/OrderService";
    import BranchService from "../../api/BranchService";
    import OrderModal from "../../components/OrderModal";
    import SettingService from "@/api/SettingService";

    export default {
        name: 'OrderIndex',
        components: {OrderModal},
        data: () => ({
            tab: 1,
            interval: null,
            selected: [],
            sources: [],
            terminals: [],
            payType: [
                {
                    id: 1,
                    name: 'Наличными'
                },
                {
                    id: 2,
                    name: 'Карта'
                },
                {
                    id: 3,
                    name: 'Онлайн-оплата'
                }
            ],
            filters: {
                created_at: {
                    valueFrom: '',
                    valueFromModal: false,
                    valueTo: '',
                    valueToModal: false,
                    tempValueFrom: '',
                    tempValueTo: '',
                    modal: false,
                },
                sum: {
                    valueFrom: '',
                    valueTo: '',
                    tempValueFrom: '',
                    tempValueTo: '',
                    modal: false,
                },
                type: {
                    value: '',
                    tempValue: '',
                    modal: false,
                },
                source: {
                    value: '',
                    tempValue: '',
                    modal: false,
                },
            },
            overlay: false,
            search: '',
            order: {},
            loading: true,
            options: {},
            footerProps: {
                itemsPerPageText: 'Заказов на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
                itemsPerPageOptions: [15, 30, -1]
            },
            total: 0,
            headers: [
                {
                    text: 'ID',
                    value: 'id',
                    sortable: false
                },
                {
                    text: 'Телефон',
                    value: 'phone',
                    sortable: false
                },
                {
                    text: 'Адрес',
                    value: 'address',
                    sortable: false,
                },
                {
                    text: 'Клиент',
                    value: 'client_name',
                },
                {
                  text: 'ID клиента',
                  value: 'client_id',
                  sortable: false
                },
                {
                    text: 'Заказ поступил',
                    value: 'created_at',
                },
                {
                  text: 'Доставить',
                  value: 'delivery_at',
                },
                {
                    text: 'Сумма',
                    value: 'sum',
                },
                {
                    text: 'Тип оплаты',
                    value: 'type_text',
                    sortable: false
                },
                {
                  text: 'Тип доставки',
                  value: 'is_local',
                },
                {
                    text: 'Источник заказа',
                    value: 'source',
                },
                {
                    text: 'Комментарий',
                    value: 'comment_for_iiko',
                    sortable: false
                },
            ],
            orders: [],
        }),
        mounted() {
            OrderService.getSources().then(response => {
                this.sources = response.data
            })

          BranchService.terminalGroups().then(response => {
            this.terminals = response.data
          })

          this.interval = setInterval(() => this.update(), 20000);
        },
        beforeDestroy() {
          clearInterval(this.interval)
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
            tab: function () {
                this.getDataFromApi()
            },
            "filters.created_at.valueFrom": {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
            "filters.created_at.valueTo": {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
            "filters.sum.valueFrom": {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
            "filters.sum.valueTo": {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
            "filters.type.value": {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
            "filters.source.value": {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
            search() {
                this.getDataFromApi()
            }
        },
        methods: {
            getPayText(id) {
                return this.payType.find(type => type.id == id).name
            },
            setCreatedAtFilter(e) {
                this.filters.created_at.valueTo = this.filters.created_at.tempValueTo
                this.filters.created_at.valueFrom = this.filters.created_at.tempValueFrom
                this.filters.created_at.modal = false;
            },
            setSumFilter(e) {
                this.filters.sum.valueTo = this.filters.sum.tempValueTo
                this.filters.sum.valueFrom = this.filters.sum.tempValueFrom
                this.filters.sum.modal = false;
            },
            setTypeFilter(e) {
                this.filters.type.value = this.filters.type.tempValue
                this.filters.type.modal = false;
            },
            setSourceFilter(e) {
                this.filters.source.value = this.filters.source.tempValue
                this.filters.source.modal = false;
            },
            getItemClass(item) {
                if (!item.iiko_id) {
                    return 'changed-row'
                }
            },
            setCategoryFilter(e) {
                this.filters.category.value = this.filters.category.tempValue
                this.filters.category.modal = false;
                this.overlay = false;
            },
            update(){
              OrderService.checkNew()
                  .then(response => {
                    if(response.data > 0){
                      var audio = new Audio(); // Создаём новый элемент Audio
                      audio.src = '/notification.mp3'; // Указываем путь к звуку "клика"
                      audio.autoplay = true; // Автоматически запускаем
                    }
                  })
            },
            getDataFromApi() {
                this.loading = true
              this.selected = [];
                let params = {
                    page: this.options.page,
                    perPage: this.options.itemsPerPage,
                    createdAtFrom: this.filters.created_at.valueFrom,
                    createdAtTo: this.filters.created_at.valueTo,
                    sumFrom: this.filters.sum.valueFrom,
                    sumTo: this.filters.sum.valueTo,
                    payType: this.filters.type.value,
                    source: this.filters.source.value,
                    sortBy: this.options.sortBy.length > 0 ? this.options.sortBy[0] : '',
                    sortDesc: this.options.sortBy.length > 0 ? this.options.sortDesc[0] : '',
                    search: this.search,
                    type: this.tab,
                }
                OrderService.list(params)
                    .then(response => {
                        this.orders = response.data.data
                        this.total = response.data.total
                        this.loading = false
                    })
            },
        }
    }
</script>

<style lang="scss">
  table {
    tr {
      &.hidden-product {
        background-color: #FFEEEC;
      }
    }
  }
  .red-circle{
    display: inline-block;
    border: 2px solid darkred;
    height: 12px;
    width: 12px;
    background-color: red;
    border-radius: 50%;
  }
</style>

<style lang="scss" scoped>

  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }

  span.v-btn {
    border-color: currentColor !important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }


    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
